import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CartouchesService, CartouchePayload } from '../../../../services/cartouches.service';
import { Chimie, ChimieService } from '../../../../services/chimie.service';
import { LotCartouche, LotsCartouchesService } from '../../../../services/lots-cartouches.service';

@Component({
	selector: 'app-cartouche-create',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './cartouche-create.component.html',
	styleUrl: './cartouche-create.component.scss'
})
export class CartoucheCreateComponent implements OnInit {
	form: CartouchePayload = {
		nom: '',
		lot_cartouche_id: undefined,
		chimie_id: undefined,
		utilise: false,
		inutilisable: false
	};
	error = '';
	success = '';
	loading = false;
	lots: LotCartouche[] = [];
	chimies: Chimie[] = [];

	constructor(
		private readonly cartouchesService: CartouchesService,
		private readonly lotsCartouchesService: LotsCartouchesService,
		private readonly chimieService: ChimieService,
		private readonly cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.lotsCartouchesService.list().subscribe({
			next: (lots: LotCartouche[]) => { this.lots = lots; this.cdr.detectChanges(); },
			error: () => { this.lots = []; this.cdr.detectChanges(); }
		});
		this.chimieService.list().subscribe({
			next: (chimies: Chimie[]) => { this.chimies = chimies; this.cdr.detectChanges(); },
			error: () => { this.chimies = []; this.cdr.detectChanges(); }
		});
	}

	create(): void {
		this.error = '';
		this.success = '';
		this.loading = true;
		this.cartouchesService.create(this.form).subscribe({
			next: () => {
				this.success = 'Cartouche créée.';
				this.form = {
					nom: '',
					lot_cartouche_id: undefined,
					chimie_id: undefined,
					utilise: false,
					inutilisable: false
				};
				this.loading = false;
				this.cdr.detectChanges();
			},
			error: (err: HttpErrorResponse) => {
				this.error = this.getErrorMessage(err, 'Erreur lors de la création.');
				this.loading = false;
				this.cdr.detectChanges();
			}
		});
	}

	private getErrorMessage(err: HttpErrorResponse, fallback: string): string {
		if (typeof err.error === 'string' && err.error.trim()) {
			return err.error;
		}
		if (err.error?.detail) {
			return err.error.detail;
		}
		if (err.error?.message) {
			return err.error.message;
		}
		if (err.message) {
			return err.message;
		}
		return fallback;
	}
}
